
import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import NewAccountStatementModal from "../../../../customer/accountstatementmodal.component"
import Icon from "../../../icon/icon.component.jsx"
import ButtonWrapper from "../../../rich-text/feature-protection-wrappers/buttonProtectionWrapper.component"



interface OwnProps {
    contactId: string
}


const AccountStatementCreationButton = (props : OwnProps) => {

    const [openModal, setOpenModal] = useState<boolean>(false)


    const handleCloseModal = (id?: string) => {
        setOpenModal(false)
        if (id && typeof id == "string") {
            window.location.href = `/account-statements/${id}/edit`
        }
    }

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    return (
        <>
            {openModal && (<NewAccountStatementModal
                contactId={props.contactId}
                onClose={handleCloseModal}
            />)}
            <ButtonWrapper
                onClick={handleOpenModal}
                className="btn btn-primary"
                protectedClassName="btn btn-primary"
            >
                <span>
                    <Icon value={"plus-circle"} />
                    <FormattedMessage
                        id="customers.account_statement.list.create_account_statement_btn"
                        defaultMessage="Create account statement"
                    />
                </span>
            </ButtonWrapper>
        </>
    )
}

export default AccountStatementCreationButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/AccountStatementCreationButton.tsx